export const truncateAddress = (
    address: string,
    firstChars: number = 6,
    lastChars: number = 4
): string => {
    if (!address) return ''
    if (address.length <= firstChars + lastChars + 3) return address
    return `${address.slice(0, firstChars)}...${address.slice(-lastChars)}`
}
